/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：4Hmg
 */

"use strict"

/* unused harmony export LanguageEnum */
/* harmony export (binding) */
/* harmony import */
export { language_list }
import * as __WEBPACK_IMPORTED_MODULE_0_react_intl__ from /* Pq8k */"react-intl"
/* harmony import */
import * as __WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en__ from /* TCl6 */"../../../../unrestored/home/react/intl/locale/data/en-TCl6"
/* harmony import */
import __WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en___default from /* TCl6 */"../../../../unrestored/home/react/intl/locale/data/en-TCl6"
/* harmony import */
import * as __WEBPACK_IMPORTED_MODULE_2_react_intl_locale_data_zh__ from /* BDH0 */"../../../../unrestored/home/react/intl/locale/data/zh-BDH0"
/* harmony import */
import __WEBPACK_IMPORTED_MODULE_2_react_intl_locale_data_zh___default from /* BDH0 */"../../../../unrestored/home/react/intl/locale/data/zh-BDH0"
/* harmony import */
import * as __WEBPACK_IMPORTED_MODULE_3__zh_CN__ from /* C38k */"../../../../unrestored/home/components/zh/CN-C38k"
/* harmony import */
import * as __WEBPACK_IMPORTED_MODULE_4__en_US__ from /* af2z */"../../../../unrestored/home/components/en/US-af2z"
/* harmony import */
import * as __WEBPACK_IMPORTED_MODULE_5__zh_TW__ from /* VaJI */"../../../../unrestored/home/components/zh/TW-VaJI"
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i]
    }
    return arr2
  } else {
    return Array.from(arr)
  }
}
// 按理来讲，应该使用 react-intl@2 来兼容这段代码，但是为了与编辑器兼容，只好把这段代码注释掉了
// __WEBPACK_IMPORTED_MODULE_0_react_intl__.addLocaleData([].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en__), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_react_intl_locale_data_zh__)))
var LanguageEnum;
(function (LanguageEnum) {
  LanguageEnum["zh"] = "zh"
  LanguageEnum["en"] = "en"
  LanguageEnum["tw"] = "tw"
})(LanguageEnum || (LanguageEnum = {}))
var language_list = {
  zh: {
    intl_lang_name: "zh",
    language: __WEBPACK_IMPORTED_MODULE_3__zh_CN__.zh_CN
  },
  tw: {
    intl_lang_name: "zh-Hant",
    language: __WEBPACK_IMPORTED_MODULE_5__zh_TW__.zh_TW
  },
  en: {
    intl_lang_name: "en",
    language: __WEBPACK_IMPORTED_MODULE_4__en_US__.en_US
  }
}

/***/
